import React, { useEffect } from "react";
import HouseProgressBar from "@/components/subcomponents/HouseProgressBar";
import { useTitle } from "@/components/provider/TitleProvider";

const BuyNowPayLater = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle("Buy Now Pay Later", "center");
  }, []);
  useEffect(() => {
    const body = document.querySelector("#root")!;
    body.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-5 sm:grid-rows-[auto_auto_auto] gap-x-4 max-w-5xl mx-auto py-8">
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Get the funds for your business now.</h5>
        <p style={{ color: "#57CB8F" }} className="text-3xl">
          <i className="bi bi-cash-stack"></i>
        </p>
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          Pay us back in instalments every 2 or 4 weeks, at a fee of 1% for every 2 weeks until we are paid back in
          full.
          <span className="block mt-2">
            If you have not paid back in full within 4 months, we'll take a shareholding in your home, until you do.
          </span>
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Shared Ownership</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={80}
          fillColor="#57CB8F"
          baseColor="#2E3745"
          shares={{
            variant: 2,
            percentageOne: 95,
            percentageTwo: 5,
          }}
          shareLabels={{
            labelOne: "Owner",
            labelTwo: "5% BuySooner",
          }}
        />
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          If your business has run into cashflow issues we can be patient and allow up to 3 years to buy out our share
          through a refinance on your home
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">100% Self Owned</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={100}
          fillColor="#2E3745"
          baseColor="#2E3745"
          shares={{
            variant: 3,
            percentageOne: 100,
            percentageTwo: 0,
          }}
        />
      </div>
    </div>
  );
};

BuyNowPayLater.propTypes = {};

export default BuyNowPayLater;
